<template>
  <router-link :to="`/services#${service.id}`" class="service-card">
    <div class="card-top">
      <span class="icon-box">
        <svg
          v-if="service.icon === 'miniProgram'"
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          stroke-width="2.6"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M38 6H10a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h8l6 8 6-8h8a4 4 0 0 0 4-4V10a4 4 0 0 0-4-4z" />
          <path d="M16 20c0-4 4-6 8-6s8 2 8 6c0 4-4 6-8 6-1 0-2-.2-2.6-.5" />
          <circle cx="30" cy="22" r="1.6" fill="currentColor" stroke="none" />
        </svg>
        <svg
          v-else-if="service.icon === 'app'"
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          stroke-width="2.6"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <rect x="10" y="4" width="28" height="40" rx="5" />
          <path d="M20 9h8" />
          <circle cx="24" cy="36" r="2.2" fill="currentColor" stroke="none" />
          <path d="M10 30l5-4-5-4" opacity="0" />
        </svg>
        <svg
          v-else-if="service.icon === 'website'"
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          stroke-width="2.6"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <rect x="5" y="9" width="38" height="30" rx="4" />
          <circle cx="16" cy="19" r="4.5" />
          <path d="M16 14v3m0 5v-2M9 30c3-4 14-5 20-1m0 0c3-3 7-4 12-3" />
        </svg>
        <svg
          v-else
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          stroke-width="2.6"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <rect x="6" y="6" width="16" height="16" rx="3" />
          <rect x="26" y="6" width="16" height="16" rx="3" />
          <rect x="6" y="26" width="16" height="16" rx="3" />
          <rect x="26" y="26" width="16" height="16" rx="3" />
          <path d="M26 34h16M34 26v16" opacity="0" />
        </svg>
      </span>
      <span class="arrow">→</span>
    </div>
    <h3>{{ service.name }}</h3>
    <p class="tagline">{{ service.tagline }}</p>
    <p class="desc">{{ service.desc }}</p>
  </router-link>
</template>

<script setup>
defineProps({
  service: { type: Object, required: true }
})
</script>

<style scoped>
.service-card {
  display: block;
  background: #fff;
  border: 1px solid var(--hl-line);
  border-radius: var(--radius);
  padding: 30px 26px;
  transition: all 0.35s ease;
  position: relative;
  overflow: hidden;
}

.service-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--hl-blue), var(--hl-cyan));
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-lg);
  border-color: transparent;
}

.service-card:hover::before {
  transform: scaleX(1);
}

.card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.icon-box {
  width: 58px;
  height: 58px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  color: var(--hl-blue);
  background: linear-gradient(135deg, rgba(11, 92, 255, 0.1), rgba(53, 194, 247, 0.12));
  transition: all 0.35s ease;
}

.icon-box svg {
  width: 34px;
  height: 34px;
}

.service-card:hover .icon-box {
  color: #fff;
  background: linear-gradient(135deg, var(--hl-blue), var(--hl-cyan));
  box-shadow: 0 8px 20px rgba(11, 92, 255, 0.35);
}

.arrow {
  font-size: 20px;
  color: var(--hl-blue);
  opacity: 0;
  transform: translateX(-8px);
  transition: all 0.35s ease;
}

.service-card:hover .arrow {
  opacity: 1;
  transform: none;
}

h3 {
  font-size: 20px;
  font-weight: 700;
  color: var(--hl-text);
}

.tagline {
  margin-top: 4px;
  font-size: 13px;
  color: var(--hl-blue);
  font-weight: 600;
}

.desc {
  margin-top: 12px;
  font-size: 14px;
  color: var(--hl-text-2);
  line-height: 1.8;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
